import { useState } from 'react';
import { useLocation } from 'react-router';
import {
  useConfirmForgotPassword,
  useSendForgotPassword,
} from 'hooks/api/changePassword';
import { protectEmailInState } from 'utils/typeGuards';
import CodeVerification from 'components/CodeVerification';
import Loader from 'components/Loader';
import VerifyResendCode from 'components/VerifyResendCode';
import messages from './ForgotPasswordVerify.messages';
import styles from './ForgotPasswordVerify.module.css';

export default function ForgotPasswordVerify() {
  const [isCodeResent, setIsCodeResent] = useState(false);
  const { state } = useLocation();

  const email = protectEmailInState(state) ? state.email : '';

  const {
    mutateAsync: confirmForgotPassword,
    isLoading,
    isError,
  } = useConfirmForgotPassword();
  const { mutateAsync: sendForgotPassword, isLoading: isLoadingSend } =
    useSendForgotPassword();

  const confirm = async (code: string) => {
    await confirmForgotPassword({ code, email });
  };

  const resendCode = async () => {
    await sendForgotPassword({ email, message: messages.successSendCode });
    setIsCodeResent(true);
  };

  const title: string = isCodeResent ? messages.titleVerify : messages.titleConfirm;
  const subtitle1: string = isCodeResent
    ? messages.subtitle1Verify
    : messages.subtitle1Confirm;

  return (
    <div className={styles.forgotPassword}>
      <h1 className={styles.forgotPassword__title}>{title}</h1>
      <p className={styles.forgotPassword__subtitle}>
        {subtitle1}
        <span className={styles.forgotPassword__email}>{email}</span>
        {messages.subtitle2}
      </p>
      <CodeVerification
        codeLength={4}
        onChange={confirm}
        loading={isLoading}
        isError={isError}
      />
      <div className={styles.forgotPassword__loaderWrapper}>
        {(isLoading || isLoadingSend) && (
          <Loader className={styles.forgotPassword__loader} />
        )}
      </div>
      <VerifyResendCode resendCode={resendCode} />
    </div>
  );
}
